import { createMiddlewareAction } from "./createMiddlewareAction";
import { endpointsBusinessunits } from "../api/endpoints";
import { businessunitsTypes } from "../constantes/actionTypes";

export const businessunitsActions = {
  getAllBusinessUnits: () =>
    createMiddlewareAction({
      successType: businessunitsTypes.GET_ALL_BUSINESSUNITS_SUCCESS,
      failureType: businessunitsTypes.GET_ALL_BUSINESSUNITS_FAILURE,
      method: "GET",
      endpoint: endpointsBusinessunits.ALL_BUSINESSUNITS,
    }),
  newBusinessUnit: (businessunit) =>
    createMiddlewareAction({
      successType: businessunitsTypes.NEW_BUSINESSUNIT_SUCCESS,
      failureType: businessunitsTypes.NEW_BUSINESSUNIT_FAILURE,
      method: "POST",
      endpoint: endpointsBusinessunits.NEW_BUSINESSUNIT,
      body: businessunit,
    }),
  updateBusinessUnit: (businessunit) =>
    createMiddlewareAction({
      successType: businessunitsTypes.UPDATE_BUSINESSUNIT_SUCCESS,
      failureType: businessunitsTypes.UPDATE_BUSINESSUNIT_FAILURE,
      method: "PUT",
      endpoint: endpointsBusinessunits.UPDATE_BUSINESSUNIT,
      body: businessunit,
    }),
  deleteBusinessUnit: (idBusinessUnit) =>
    createMiddlewareAction({
      successType: businessunitsTypes.DELETE_BUSINESSUNIT_SUCCESS,
      failureType: businessunitsTypes.DELETE_BUSINESSUNIT_FAILURE,
      method: "DELETE",
      endpoint: endpointsBusinessunits.DELETE_BUSINESSUNIT(idBusinessUnit),
    }),
};
